var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "9.943 9 15.128 14.185 14.185 15.128 9 9.943 3.815 15.128 2.872 14.185 8.057 9 2.872 3.815 3.815 2.872 9 8.057 14.185 2.872 15.128 3.815"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLarge);
export default __webpack_public_path__ + "static/media/close-large.d7a7147b9de99c9574fb29efd066c364.svg";
export { ForwardRef as ReactComponent };